import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { StyleHelper } from '@xanadu/common';
import { DynamicComponent } from '@xanadu/core';
import { CommonSignal } from '@xanadu/signal';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogComponent extends DynamicComponent {
    private readonly commonSignal = inject(CommonSignal);
    readonly styleHelper = inject(StyleHelper);

    style: any;
    display = false;

    readonly consent = this.commonSignal.consent;

    constructor() {
        super();

        effect(() => {
            const consent = this.consent();

            if (consent && consent.data) {
                if (consent.data.style) {
                    this.style = consent.data.style ? this.styleHelper.parse(consent.data.style) : null;
                } else {
                    this.style = null;
                }

                this.display = true;
            } else {
                this.onClose();
            }
        });

        effect(() => {
            const reply = this.commonSignal.reply();
            if (reply) {
                this.onClose();
            }
        });
    }

    onClose() {
        this.commonSignal.consent.set(undefined);
        this.display = false;
    }

    onStop(event: PointerEvent) {
        event.stopPropagation();
    }
}
